// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4614":"css/app.6693","6897":"css/admin-app.6693"}[chunkId] + ".css";
};